export default "__VITE_ASSET__BMcctid3__"